// extracted by mini-css-extract-plugin
export default {"LoginPage":"style_LoginPage__zQbiq"};